<div>
	<p-dialog styleClass="custom-snmp-history-dialog" appendTo="body" [(visible)]="visible" (onHide)="hide()" [modal]="true" [resizable]="false"
			  [style]="{'width': '920px', 'height': '700px'}">

		<p-header>
			<span>Device / SNMP Values</span>
		</p-header>

		<div>

			<custom-snmp-history [visible]="visible" [monitorType]="monitorType" [deviceGuid]="deviceGuid"
								  [monitorPolicyGuid]="monitorPolicyGuid">
			</custom-snmp-history>

		</div>

		<p-footer>
			<button type="button" pButton icon="fa fa-close" (click)="hide()" label="Close"></button>
		</p-footer>

	</p-dialog>

</div>